import React from 'react'

import cn from 'classnames'

interface CardProps extends React.PropsWithChildren {
    style?: React.CSSProperties
    className?: string
}

const Card: React.FC<CardProps> = props => {
    const { children, style, className } = props

    return (
        <div className={'flex w-[421px] max-w-full justify-center rounded-[20px] border border-white'} style={style}>
            <div className={cn('card-container flex w-[28rem] flex-col justify-between p-6', className)}>
                {children}
            </div>
        </div>
    )
}

export default Card
